import React, { useEffect, useState } from "react";
import { ValidateResponse } from "../../../app/helpers/global";
import { getAvailableSerialnumbers } from "../../../app/helpers/transport";
import { Message } from "../../Message";
import { FormRender } from "../Render";

export function FormInputSerialnumber({
    setValues, // required
    fieldValue = {},  // data object {locationId:.., departmentId:.., room:..} optional
    fieldLabel = { productId: "Selecteer serienummer" },  // optional
    sourceReference, // required ! sould contain the transportreqeustid
    identifier, // optional
    // fields = { warehouseId: "warehouseId"} // choose the fields to show on location & pass the names. 
}) {

    const [error, setError] = useState();
    const [message, setMessage] = useState();
    const [serialnumbers, setSerialNumbers] = useState({});
    const [isLoaded, setIsLoaded] = useState(false);
    const productId = fieldValue.productId ?? '';


    useEffect(() => {

        let inputData = {
            "sourceReference": sourceReference,
            "productId": productId
        }

        getAvailableSerialnumbers(inputData).then((res) => {

            const response = ValidateResponse(res.data, 'serialnumbers');

            if (response.status === 'success') {
                if (response.serialnumbers !== null) {
                    setSerialNumbers(response.serialnumbers);
                }
                if (response.message !== undefined && response.message !== null) {
                    setMessage(response.message);
                }
                setIsLoaded(true);
            }
            else {
                setError(response.message);
            }
        }).catch((error) => {
            const response = ValidateResponse(error, 'status');
            setError(response.message);
        });

    }, [productId, sourceReference, setMessage]);

    const handleValues = (name, value) => {
        setValues(name, value, identifier);
    }

    if (error !== undefined) {
        return (<Message type="error" message={error} />);
    }
    if (isLoaded === false) {
        return (<Message type="loading" />);
    }

    if (message === undefined) {
        return <FormRender
            setValues={handleValues}
            fieldType="select"
            fieldName="productId"
            fieldValue={productId}
            fieldLabel={fieldLabel.productId}
            identifier={identifier}
            fieldOptions={serialnumbers}
        />
    }
    else {
        return (
            <>
                <div className="form__component">
                    <Message type="warning" message={message} />
                </div>
                <FormRender
                    setValues={handleValues}
                    fieldType="select"
                    fieldName="productId"
                    fieldValue={productId}
                    fieldLabel={fieldLabel.productId}
                    identifier={identifier}
                    fieldOptions={serialnumbers}
                />
            </>
        );
    }
}